import React from "react";
import { StyledFullTextLink } from "./_styled";

const actionKey = [13, 32];

export default function useDoiLinkProcessor(options) {
  const { openFtfDialog } = options;

  const processDoiLink = (node) => {
    const doAction = () => {
      openFtfDialog(node.attribs["data-value"], "doi");
    };

    const handleKeyDown = (event) => {
      if (actionKey.includes(event.keyCode)) {
        doAction();
      }
    };

    return (
      <>
        <span>&nbsp;&bull;&nbsp;</span>
        <StyledFullTextLink
          onClick={doAction}
          onKeyDown={handleKeyDown}
          data-testid="doi-ftlink-button"
        >
          Full Text/Abstract
        </StyledFullTextLink>
      </>
    );
  };

  return { processDoiLink };
}
